export interface Subfolder {
  id: number;
  name: string;
  uploadedBy: string;
  uploadedAt: string;
  companyName: string;
}

export interface Document {
  id: number;
  name: string;
  createdBy: string;
  createdAt: string;
  size: number;
  category: string;
  companyName: string;
}

export interface Folder {
  folderId: number;
  folderName: string;
  parentId: string;
  files: Document[];
  folders: Subfolder[];
  companyId: string | null;
  totalCount: number;
}

export interface Company {
  name: string;
  id: string;
}

export const categories = [
  { key: 'SOP', value: 'SOP' },
  { key: 'Certificates', value: 'Certificates' },
  { key: 'Rates', value: 'Rates' },
  { key: 'Reports', value: 'Reports' },
  { key: 'Contacts', value: 'Contacts' },
  { key: 'Contracts', value: 'Contacts' },
  { key: 'InternalDocumentOnly', value: 'Internal Document Only' },
  { key: 'Other', value: 'Other' }
];

export const defaultPageNumber = 1;
